import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  onSelectionChange() {
    this.element.submit();
  }
}
